import { useEffect, useState } from "react";
import { Constants } from "../Constants";
import { useProfileData } from "./useProfileData";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

export const useFeedbackPageUrl = () => {
    const { instance, inProgress } = useMsal();
    const [feedbackPageUrl, setFeedbackPageUrl] = useState('');
    const { profileData } = useProfileData(inProgress, instance);

    useEffect(() => {
        if (inProgress === InteractionStatus.None && profileData) {
            const feedbackUrl = new URL(window.location.href);
            feedbackUrl.pathname = Constants.navigation.urls.feedback;

            const params = {
                name: profileData.displayName,
                directorate: profileData.directorate,
                lineofbusiness: profileData.stream,
                email: profileData.mail,
                jobTitle: profileData.jobTitle
            };
            feedbackUrl.search = new URLSearchParams(params).toString();

            setFeedbackPageUrl(feedbackUrl.toString());
        }
    }, [inProgress, profileData]);

    return feedbackPageUrl;

};